import { MouseEvent } from 'react';

import { StyledTableBodyCell, StyledTableBodyRow } from './TableBodyRows.styles';
import { TableBodyRowsProps } from './TableBodyRows.types';

export function TableBodyRows<T>({ data, columns, rowClickable, onRowClick }: TableBodyRowsProps<T>): JSX.Element {
  const handleRowClick = (event: MouseEvent<HTMLTableRowElement>, item: any, index: number): void => {
    onRowClick?.(event, item, index);
  };

  return (
    <>
      {data?.map((item: T, itemIndex) => (
        <StyledTableBodyRow
          key={`table-body-${itemIndex}`}
          clickable={rowClickable}
          css={{ backgroundColor: itemIndex % 2 ? '$white' : '$seafoam700' }}
          onClick={(event) => handleRowClick(event, item, itemIndex)}
        >
          {columns?.map((column, columnIndex) => {
            const value = (item as any)[column.key];
            return (
              <StyledTableBodyCell
                key={`table-row-cell-${columnIndex}`}
                data-testid={`table-row-cell-${itemIndex}-${column.key}`}
              >
                {column.render ? column.render(column, item) : value}
              </StyledTableBodyCell>
            );
          })}
        </StyledTableBodyRow>
      ))}
    </>
  );
}
